<div class="contracts-wrap">

  <!-- Spinner -->
  @if (isLoading) {
    <div class="spinner-container">
      <div class="spinner"></div>
    </div>
  }

  <!-- Content -->
  @if (!isLoading) {

    <!-- Contract tab row -->
    <div class="contract-tabs">
      @for (c of data; track c; let i = $index) {
        <div class="contract-tab"
              [class.active]="activeContract == i"
              (click)="activeContract = i">
          <span class="tab-dot"></span>
          <span class="tab-name">{{ c.contract_name }}</span>
        </div>
      }
    </div>

    <!-- Two-column contract detail -->
    <div class="contract-detail">

      <!-- Status column -->
      <div class="detail-col">
        <div class="col-title">{{ 'BILLING.STATUS' | translate }}</div>
        <div class="detail-row">
          <span class="row-label">{{ 'BILLING.CURRENT_BILLING' | translate }}</span>
          <span class="row-val">{{ currentBilling }}</span>
        </div>
        <div class="detail-row">
          <span class="row-label">{{ 'BILLING.ACTIVE_SINCE' | translate }}</span>
          <span class="row-val">{{ activeSince }}</span>
        </div>
        <div class="detail-row">
          <span class="row-label">{{ 'BILLING.CHARGEABLE_UNITS_LABEL' | translate }}</span>
          <span class="row-val">{{ selected.current_num_of_chargeable_units }} <span class="val-sub">{{ 'BILLING.CURRENT_CAP' | translate }}</span></span>
        </div>
        <div class="detail-row last">
          <span class="row-label">{{ 'BILLING.CONTRACT_DURATION' | translate }}</span>
          <span class="row-val">{{ selected.contract_duration_in_months }} {{ (selected.contract_duration_in_months === 1 ? 'BILLING.MONTH_SHORT' : 'BILLING.MONTHS_SHORT') | translate }}</span>
        </div>
      </div>

      <!-- Pricing List column -->
      <div class="detail-col">
        <div class="col-title">{{ 'BILLING.PRICING_LIST' | translate }}</div>
        @for (et of selected.event_types; track et; let last = $last) {
          <div class="detail-row" [class.last]="last">
            <span class="row-label">{{ eventTypeName(et) }}</span>
            <span class="row-val">{{ eventTypeValue(et) }}</span>
          </div>
        }
      </div>

    </div>

  } <!-- end @if (!isLoading) -->

</div>
